/**
 * Ereignisvertrag der Echtzeitkommunikation (§22).
 *
 * **Ein Ereignis ist ein Anstoß, keine Auskunft.** Es sagt ausschließlich, *dass* sich etwas
 * geändert hat; *was* sich geändert hat, holt der Client anschließend über denselben
 * HTTP-Endpunkt, den auch das Polling verwendet (Entscheidung E18 in `docs/ARCHITECTURE.md`).
 *
 * Daraus folgt die Sicherheitszusage dieses Moduls unmittelbar: Die Nutzdaten haben **kein** Feld
 * für eine Auswahl (§14), keines für eine Stimmenverteilung (§16) und keines für Beteiligungs-
 * oder Ergebniszahlen. Was nicht vorgesehen ist, kann nicht versehentlich übertragen werden —
 * dieselbe Denkweise wie beim getrennten Datenmodell aus §14.2 und beim Textbaum aus §12.
 */
/**
 * Pfad des Socket.IO-Endpunkts.
 *
 * Entspricht der Vorgabe von Socket.IO und ist im Reverse-Proxy für das WebSocket-Upgrade
 * freizuschalten (§34.6). Der Entwicklungsserver leitet ihn bereits weiter.
 */
export const SOCKET_PFAD = '/socket.io';
/**
 * Die Ereignisse, die der Server sendet.
 *
 * Es gibt bewusst nur eines. Jede Unterscheidung steckt im Anlass, nicht im Ereignisnamen — so
 * kann eine Oberfläche nie ein Ereignis übersehen, das sie nicht kennt.
 */
export const ECHTZEIT_EREIGNIS = {
    ZUSTAND_GEAENDERT: 'zustand.geaendert',
};
/**
 * Der Anlass einer Zustandsänderung (§22.1).
 *
 * Der Anlass dient der Oberfläche zur Entscheidung, **welche** Abfrage zu erneuern ist, und der
 * Verständlichkeit in der Fehlersuche. Er trägt selbst keine fachlichen Daten.
 */
export const ECHTZEIT_ANLASS = {
    ABSTIMMUNG_GEOEFFNET: 'abstimmung.geoeffnet',
    ABSTIMMUNG_GESCHLOSSEN: 'abstimmung.geschlossen',
    ABSTIMMUNG_ANNULLIERT: 'abstimmung.annulliert',
    ERGEBNIS_VEROEFFENTLICHT: 'ergebnis.veroeffentlicht',
    ERGEBNIS_BEENDET: 'ergebnis.beendet',
    /** Ergebnisfeststellung oder Berichtigungsvermerk haben sich geändert (§18.4, §18.5). */
    ERGEBNIS_GEAENDERT: 'ergebnis.geaendert',
    /** Alle Teilnehmer wurden in den Warteraum zurückgesetzt (§19.2). */
    WARTERAUM: 'warteraum',
    VERANSTALTUNG_GEAENDERT: 'veranstaltung.geaendert',
    VERANSTALTUNG_BEENDET: 'veranstaltung.beendet',
    /** Eine Teilnehmersitzung wurde übernommen, beendet oder gesperrt (§9.6, §9.8). */
    SITZUNG_BEENDET: 'sitzung.beendet',
    /** Die Beteiligungszahlen im Backend haben sich geändert (§22.1). Niemals die Zahlen selbst. */
    BETEILIGUNG: 'beteiligung',
    /** Anwesenheit, Tokenstatus oder Verbindungsstand haben sich geändert (§9.8). */
    TEILNEHMER: 'teilnehmer',
    /**
     * Fortschritt oder Abschluss eines E-Mail-Versands der Zugangskarten (ÄA-7). Wie jeder Anlass
     * nur ein Anstoß — der Client fragt den Fortschritt danach über den Statusendpunkt ab.
     */
    EMAIL_VERSAND: 'email_versand.aktualisiert',
};
/** Die Felder, die {@link ZustandGeaendert} tragen darf — Grundlage des Vertragstests. */
export const ZUSTAND_GEAENDERT_FELDER = ['anlass', 'veranstaltungId'];
//# sourceMappingURL=echtzeit.js.map